import {
    GET_USER_REQUEST, GET_USER_SUCCESS, GET_USER_FAIL,
    GET_ALL_USERS_REQUEST, GET_ALL_USERS_SUCCESS, GET_ALL_USERS_FAIL,
    GET_USERS_BY_STATUS_REQUEST, GET_USERS_BY_STATUS_SUCCESS, GET_USERS_BY_STATUS_FAIL,
    GET_USERS_BY_JOB_REQUEST, GET_USERS_BY_JOB_SUCCESS, GET_USERS_BY_JOB_FAIL,
    GET_USERS_BY_ENTITY_REQUEST, GET_USERS_BY_ENTITY_SUCCESS, GET_USERS_BY_ENTITY_FAIL,
    CREATE_USER_REQUEST, CREATE_USER_SUCCESS, CREATE_USER_FAIL,
    UPDATE_USER_REQUEST, UPDATE_USER_SUCCESS, UPDATE_USER_FAIL,
    DELETE_USER_REQUEST, DELETE_USER_SUCCESS, DELETE_USER_FAIL,
    ASSIGN_ROLES_REQUEST, ASSIGN_ROLES_SUCCESS, ASSIGN_ROLES_FAIL,
    REMOVE_ROLES_REQUEST, REMOVE_ROLES_SUCCESS, REMOVE_ROLES_FAIL,
    SET_LOADING, UPDATE_USER, MASS_IMPORT_USERS_FAIL, MASS_IMPORT_USERS_SUCCESS, MASS_IMPORT_USERS_REQUEST,
    IMPORT_USERS_MASS_SUCCESS, REVIEW_USERS_MASS_IMPORT_FAIL, IMPORT_USERS_MASS_FAIL, REVIEW_USERS_MASS_IMPORT_SUCCESS,
    GET_TROMBINOSCOPE_REQUEST, GET_TROMBINOSCOPE_SUCCESS, GET_TROMBINOSCOPE_FAILURE,
    GET_USER_JOB_HISTORY_REQUEST,
    GET_USER_JOB_HISTORY_SUCCESS,
    GET_USER_JOB_HISTORY_FAILURE,
    CLEAR_USER_JOB_HISTORY, GET_DIRECT_REPORTS_REQUEST, GET_DIRECT_REPORTS_SUCCESS, GET_DIRECT_REPORTS_FAIL,
    UPDATE_MY_PROFILE_REQUEST, UPLOAD_USER_PHOTO_REQUEST, UPDATE_MY_PROFILE_SUCCESS, UPLOAD_USER_PHOTO_SUCCESS,
    UPDATE_MY_PROFILE_FAIL, UPLOAD_USER_PHOTO_FAIL,
    UPLOAD_ATTESTATION_RIB_REQUEST, UPLOAD_ATTESTATION_RIB_SUCCESS, UPLOAD_ATTESTATION_RIB_FAIL,

} from '../actions/userActions';

const initialState = {
    users: [],
    currentUser: null,
    user: {},
    massImportReview: null, // { errors, warnings, totalRows, validRows }
    massImportResult: null,
    loadingByUserId: {},  // { [userId]: true/false }
    errorByUserId: {},    // { [userId]: "msg" }
    historyByUserId: {},
    trombinoscope: [],
    trombinoscopeLoading: false,
    trombinoscopeError: null,
    loading: false,
    directReports: [],
    directReportsLoading: false,
    directReportsError: null,
    message: '',
    error: null
};

function userReducer(state = initialState, action) {
    switch (action.type) {
        case UPDATE_USER:
            return {
                ...state,
                user: action.payload,  // ✅ Lire depuis payload
                loading: false
            };
        case GET_USER_JOB_HISTORY_REQUEST: {
            const { userId } = action.payload;
            return {
                ...state,
                loadingByUserId: { ...state.loadingByUserId, [userId]: true },
                errorByUserId: { ...state.errorByUserId, [userId]: null },
            };
        }

        case GET_USER_JOB_HISTORY_SUCCESS: {
            const { userId, data } = action.payload;
            return {
                ...state,
                loadingByUserId: { ...state.loadingByUserId, [userId]: false },
                historyByUserId: { ...state.historyByUserId, [userId]: data || [] },
            };
        }

        case GET_USER_JOB_HISTORY_FAILURE: {
            const { userId, error } = action.payload;
            return {
                ...state,
                loadingByUserId: { ...state.loadingByUserId, [userId]: false },
                errorByUserId: { ...state.errorByUserId, [userId]: error || "Erreur" },
            };
        }

        case CLEAR_USER_JOB_HISTORY: {
            return initialState;
        }

        case UPDATE_MY_PROFILE_REQUEST:
        case UPLOAD_USER_PHOTO_REQUEST:
        case UPLOAD_ATTESTATION_RIB_REQUEST:
            return { ...state, loading: true, error: null };

        case UPDATE_MY_PROFILE_SUCCESS:
        case UPLOAD_USER_PHOTO_SUCCESS:
        case UPLOAD_ATTESTATION_RIB_SUCCESS:
            return {
                ...state,
                loading: false,
                currentUser: action.payload,
                users: state.users.map(u =>
                    u.id === action.payload.id ? action.payload : u
                ),
            };

        case UPDATE_MY_PROFILE_FAIL:
        case UPLOAD_USER_PHOTO_FAIL:
        case UPLOAD_ATTESTATION_RIB_FAIL:
            return { ...state, loading: false, error: action.payload };



        case GET_TROMBINOSCOPE_REQUEST:
            return { ...state, trombinoscopeLoading: true, trombinoscopeError: null };

        case GET_TROMBINOSCOPE_SUCCESS:
            return { ...state, trombinoscopeLoading: false, trombinoscope: action.payload || [] };

        case GET_TROMBINOSCOPE_FAILURE:
            return { ...state, trombinoscopeLoading: false, trombinoscopeError: action.payload };
        case REVIEW_USERS_MASS_IMPORT_SUCCESS:
            return { ...state, loading: false, massImportReview: action.payload };

        case REVIEW_USERS_MASS_IMPORT_FAIL:
            return { ...state, loading: false, error: action.error };

        case IMPORT_USERS_MASS_SUCCESS:
            return {
                ...state,
                loading: false,
                users: action.payload, // ou concat si tu veux
                massImportResult: action.payload,
            };

        case IMPORT_USERS_MASS_FAIL:
            return { ...state, loading: false, error: action.error };


        case MASS_IMPORT_USERS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                message: "",
            };

        case MASS_IMPORT_USERS_SUCCESS:
            return {
                ...state,
                // choix 1 : remplacer la liste par la réponse backend
                users: action.payload,
                loading: false,
                error: null,
                message: "Import effectué avec succès",
            };

        case MASS_IMPORT_USERS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error,
                message: "Erreur lors de l'import",
            };

        case SET_LOADING:
            return {
                ...state,
                loading: action.payload
            };

        case GET_USER_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_USER_SUCCESS:
            return {
                ...state,
                currentUser: action.payload,
                loading: false,
                message: 'Utilisateur récupéré avec succès'
            };

        case GET_USER_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error,
                message: 'Échec de la récupération'
            };

        case GET_ALL_USERS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_ALL_USERS_SUCCESS:
            return {
                ...state,
                users: action.payload,
                loading: false,
                message: 'Utilisateurs récupérés avec succès'
            };

        case GET_ALL_USERS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        case GET_USERS_BY_STATUS_REQUEST:
        case GET_USERS_BY_JOB_REQUEST:
        case GET_USERS_BY_ENTITY_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_USERS_BY_STATUS_SUCCESS:
        case GET_USERS_BY_JOB_SUCCESS:
        case GET_USERS_BY_ENTITY_SUCCESS:
            return {
                ...state,
                users: action.payload,
                loading: false
            };

        case GET_USERS_BY_STATUS_FAIL:
        case GET_USERS_BY_JOB_FAIL:
        case GET_USERS_BY_ENTITY_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        case CREATE_USER_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case CREATE_USER_SUCCESS:
            return {
                ...state,
                users: [...state.users, action.payload],
                loading: false,
                message: 'Utilisateur créé avec succès'
            };

        case CREATE_USER_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        case UPDATE_USER_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case UPDATE_USER_SUCCESS:
            return {
                ...state,
                users: state.users.map(user =>
                    user.id === action.payload.id ? action.payload : user
                ),
                currentUser: state.currentUser?.id === action.payload.id
                    ? action.payload
                    : state.currentUser,
                loading: false,
                message: 'Utilisateur mis à jour avec succès'
            };

        case UPDATE_USER_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        case DELETE_USER_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case DELETE_USER_SUCCESS:
            return {
                ...state,
                users: state.users.filter(user => user.id !== action.payload),
                currentUser: state.currentUser?.id === action.payload
                    ? null
                    : state.currentUser,
                loading: false,
                message: 'Utilisateur supprimé avec succès'
            };

        case DELETE_USER_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        case ASSIGN_ROLES_REQUEST:
        case REMOVE_ROLES_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case ASSIGN_ROLES_SUCCESS:
        case REMOVE_ROLES_SUCCESS:
            return {
                ...state,
                users: state.users.map(u => u.id === action.payload?.id ? action.payload : u),
                currentUser: state.currentUser?.id === action.payload?.id
                    ? action.payload
                    : state.currentUser,
                loading: false,
                message: 'Rôles modifiés avec succès'
            };

        case ASSIGN_ROLES_FAIL:
        case REMOVE_ROLES_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        case GET_DIRECT_REPORTS_REQUEST:
            return {
                ...state,
                directReportsLoading: true,
                directReportsError: null
            };

        case GET_DIRECT_REPORTS_SUCCESS:
            return {
                ...state,
                directReportsLoading: false,
                directReports: action.payload || []
            };

        case GET_DIRECT_REPORTS_FAIL:
            return {
                ...state,
                directReportsLoading: false,
                directReportsError: action.error
            };

        default:
            return state;
    }
}

export default userReducer;
